import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Product } from '../../types';
import ProductCard from '../ProductCard/ProductCard';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './ProductCarousel.css';

interface ProductCarouselProps {
    products: Product[];
    onProductClick?: (product: Product) => void;
}

const ProductCarousel: React.FC<ProductCarouselProps> = ({ products, onProductClick }) => {
    return (
        <div className="product-carousel">
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                grabCursor={true}
                centeredSlides={false}
                slidesPerView={1}
                spaceBetween={30}
                pagination={{
                    clickable: true,
                    dynamicBullets: true,
                }}
                navigation={true}
                autoplay={{
                    delay: 5001,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
                loop={products.length > 3}
                breakpoints={{
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1400: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                }}
                className="product-swiper"
            >
                {products.map((product) => (
                    <SwiperSlide key={product.id}>
                        <ProductCard
                            product={product}
                            onClick={() => onProductClick && onProductClick(product)}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default ProductCarousel;
